/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillOverridesControllerUpsertMutationResponse, SkillOverridesControllerUpsert400, SkillOverridesControllerUpsert401, SkillOverridesControllerUpsert403, SkillOverridesControllerUpsert404 } from "../../models/skillOverridesController/SkillOverridesControllerUpsert";

function getSkillOverridesControllerUpsertUrl() {
  const res = { method: 'PUT', url: `/api/v1/skill-overrides` as const }  
  return res
}

/**
 * @summary Create or update a skill override
 * {@link /api/v1/skill-overrides}
 */
export async function skillOverridesControllerUpsert(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillOverridesControllerUpsertMutationResponse, ResponseErrorConfig<SkillOverridesControllerUpsert400 | SkillOverridesControllerUpsert401 | SkillOverridesControllerUpsert403 | SkillOverridesControllerUpsert404>, unknown>({ method : "PUT", url : getSkillOverridesControllerUpsertUrl().url.toString(), ... requestConfig })  
  return res.data
}